const state = {
  dialogShow: true,
  groupIdList: {
    innerGroupId: '',
    outGroupId: ''
  }
}
const mutations = {
  DIALOG_SHOW: (state, dialogShow) => {
    state.dialogShow = dialogShow
  },
  SET_GROUP_ID_LIST: (state, groupIdList) => {
    console.log('store需要传给im的群组id========', groupIdList)
    state.groupIdList = groupIdList
  }
}

export default {
  state,
  mutations
}
